import Swiper from "./swiper-bundle.esm.browser.min.js";
customElements.get("slideshow-section") || customElements.define("slideshow-section", class extends HTMLElement {
   constructor() {
      super(), this.swiper = null, this.configuration = null, this.handleKeyboard = this.handleKeyboard.bind(this)
   }
   handleTabindex(swiper) {
      const isSlidesGroup = this.hasAttribute("data-slides-group"),
         focusableSelectors = "a, button, input, textarea, select, [tabindex]",
         totalSlides = swiper.slides.length,
         slidesPerView = swiper.params.slidesPerView;
      swiper && totalSlides > slidesPerView ? swiper.slides.forEach(slide => {
         if (isSlidesGroup) {
            const slideRect = slide.getBoundingClientRect(),
               swiperRect = this.getBoundingClientRect(),
               isFullyVisible = slideRect.left >= swiperRect.left && slideRect.right <= swiperRect.right && slideRect.top >= swiperRect.top && slideRect.bottom <= swiperRect.bottom;
            slide.querySelectorAll(focusableSelectors).forEach(el => {
               isFullyVisible ? el.setAttribute("tabindex", "0") : el.setAttribute("tabindex", "-1"), el.hasAttribute("data-omit-tabindex") && el.setAttribute("tabindex", "-1")
            })
         } else swiper.slides.forEach(slide2 => {
            slide2.querySelectorAll(focusableSelectors).forEach(el => {
               el.setAttribute("tabindex", "-1")
            })
         }), swiper.slides[swiper.activeIndex]?.querySelectorAll(focusableSelectors).forEach(el => {
            el.setAttribute("tabindex", el.hasAttribute("data-omit-tabindex") ? "-1" : "0")
         })
      }) : swiper.slides.forEach(slide => {
         slide.querySelectorAll(focusableSelectors).forEach(el => {
            el.setAttribute("tabindex", el.hasAttribute("data-omit-tabindex") ? "-1" : "0")
         })
      })
   }
   handleKeyboard(event) {
      const keyCode = event.keyCode || event.which,
         focusedElement = document.activeElement;
      if (this.swiper && this.swiper.el.contains(focusedElement)) switch (keyCode) {
         case 37:
            this.swiper.slidePrev();
            break;
         case 39:
            this.swiper.slideNext();
            break
      }
   }
   connectedCallback() {
      this.readConfiguration(), this.initializeOrDestroySwiperForBrands = this.initializeOrDestroySwiperForBrands.bind(this), this.centerNavigation = this.centerNavigation.bind(this), this.shouldSkipCenterNavMethod = this.dataset.skipCenterNavMethod === "true", window.innerWidth < 900 && !this.swiper && this.swiperInitilize(), window.addEventListener("resize", this.centerNavigation), this.dataset.brands === "true" ? window.addEventListener("resize", this.initializeOrDestroySwiperForBrands) : this.configuration.enableOnMedia ? (window.addEventListener("resize", this.matchResolution.bind(this)), this.breakpoint = window.matchMedia(this.configuration.enableOnMedia), this.matchResolution()) : this.swiper || this.swiperInitilize(), window.addEventListener("keydown", this.handleKeyboard)
   }
   disconnectedCallback() {
      window.removeEventListener("resize", this.initializeOrDestroySwiperForBrands), window.removeEventListener("resize", this.centerNavigation), window.removeEventListener("keydown", this.handleKeyboard)
   }
   initializeOrDestroySwiperForBrands() {
      window.innerWidth < 900 ? this.swiper || this.swiperInitilize() : this.swiper && this.swiperDestroy()
   }
   centerNavigation() {
      if (window.innerWidth < 900 || this.shouldSkipCenterNavMethod) return;
      const picture = this.querySelector("picture")?.classList.contains("hero__pic--mobile") ? this.querySelectorAll("picture")[1] : this.querySelector("picture");
      if (picture) {
         const boundingClientRectPic = picture.getBoundingClientRect();
         this.querySelectorAll(".wt-slider__nav-btn").forEach(btn => btn.style.top = `${22+boundingClientRectPic.height/2}px`)
      }
   }
   readConfiguration() {
      const default_configuration = {
            autoHeight: !1,
            slidesPerView: 1,
            autoplay: !1,
            threshold: 5,
            pagination: {
               el: ".swiper-pagination",
               renderBullet(index, className) {
                  return `<span class="${className} swiper-pagination-bullet--svg-animation"><svg width="20" height="20" viewBox="0 0 28 28"><circle class="svg__circle" cx="14" cy="14" r="12" fill="none" stroke-width="2"></circle><circle class="svg__circle-inner" cx="14" cy="14" r="5" stroke-width="2"></circle></svg></span>`
               }
            },
            navigation: {
               nextEl: ".wt-slider__nav-next",
               prevEl: ".wt-slider__nav-prev"
            },
            scrollbar: !1,
            on: {
               afterInit: swiper => {
                  const dataSwiper = this.querySelector("[data-swiper]"),
                     dataSwiperContainer = this.querySelector("[data-swiper-container]");
                  dataSwiper?.classList.remove("loading"), dataSwiperContainer?.classList.remove("loading"), this.centerNavigation(), this.handleTabindex(swiper)
               },
               slideChangeTransitionEnd: swiper => {
                  this.handleTabindex(swiper)
               }
            }
         },
         get_custom_configuration = this.querySelector("[data-swiper-configuration]")?.innerHTML,
         custom_configuration = get_custom_configuration ? JSON.parse(get_custom_configuration) : {};
      if (this.configuration = {
            ...default_configuration,
            ...custom_configuration
         }, this.configuration.autoplay) {
         if (window.innerWidth < 900) var override_configuration = {
            autoplay: !1
         };
         this.configuration = {
            ...this.configuration,
            ...override_configuration
         }
      }
   }
   matchResolution() {
      this.breakpoint.matches === !0 ? this.swiper || this.swiperInitilize() : this.swiper && this.swiperDestroy()
   }
   swiperInitilize() {
      const node = this,
         container = this.querySelector("[data-swiper]");
      this.querySelector("[data-swiper]").classList.add("swiper", "wt-slider__container"), this.querySelector("[data-swiper-container]").classList.add("swiper-wrapper", "wt-slider__wrapper"), this.querySelectorAll("[data-swiper-slide]").forEach(function (e) {
         e.classList.add("swiper-slide", "wt-slider__slide")
      }), this.swiper = new Swiper(container, this.configuration)
   }
   swiperDestroy() {
      this.querySelector("[data-swiper]").classList.remove("swiper", "wt-slider__container"), this.querySelector("[data-swiper-container]").classList.remove("swiper-wrapper", "wt-slider__wrapper"), this.querySelectorAll("[data-swiper-slide]").forEach(function (e) {
         e.classList.remove("swiper-slide", "wt-slider__slide")
      }), this.swiper.destroy(), this.querySelector(".swiper-pagination") && (this.querySelector(".swiper-pagination").innerHTML = ""), this.swiper = null
   }
   slideTo(slide) {
      this.swiper.autoplay.stop();
      const index = Array.from(slide.parentNode.children).indexOf(slide);
      this.swiper.slideTo(index)
   }
});
//# sourceMappingURL=/cdn/shop/t/18/assets/slider.js.map?v=79897156492709988811752578292